function includeFilterFn(rows, id, filterValues) {
  if (filterValues) {
    return rows.filter((row) => row.values[id] === filterValues);
  } else {
    return rows;
  }
}

export default includeFilterFn;
